import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureEnum } from '../../models/program-api-models';
import { FeatureService } from './feature.service';

export function featureGuard(feature: FeatureEnum): CanActivateFn {
  return async () => {
    const featureService = inject(FeatureService);
    const router = inject(Router);
    return (await featureService.isFeatureEnabled(feature)) || router.createUrlTree(['/']);
  };
}
